import TreeModel from 'tree-model'
import { uniqueId } from 'lodash'

const transformAttributes = function (dataSource, dataId, rootFamily, freeze = true) {
  const treeModel = new TreeModel()
  const node = treeModel.parse(dataSource)
  const attributes = []
  node.walk({ strategy: 'post' }, node => {
    // all attributes have a type, if no type exists, it is a parent group
    const attr = node.model
    if (attr.type) {
      if (!attr.dataset && dataId) {
        attr.dataset = dataId
      }
      if (!attr.rootFamily && rootFamily) {
        attr.rootFamily = rootFamily
      }
      // add a string representation of the hierarchy
      attr.path = node
        .getPath()
        .map(pathNode => {
          return pathNode.model !== node.model && !pathNode.isRoot() ? pathNode.model.name : undefined
        })
        .filter(n => n !== undefined)
        .join(' / ')
      // immediate parent name for the target definition
      attr.parent = node.getPath().length > 2 ? node.parent.model.name : ''
      if (freeze) {
        Object.freeze(attr)
      }
      attributes.push(attr)
    }
    if (typeof attr.id === 'undefined') {
      attr.id = uniqueId(dataId)
    }
  })
  let data = dataSource
  let flat = {
    name: dataSource.name,
    attributes,
  }
  if (freeze) {
    flat = Object.freeze(flat)
    data = Object.freeze(data)
  }
  return { data, flat }
}

export default transformAttributes

export const getAttributes = function (dataSource) {
  const treeModel = new TreeModel()
  const node = treeModel.parse(dataSource)
  const attributes = []
  node.walk({ strategy: 'post' }, node => {
    // all attributes have a type, if no type exists, it is a parent group
    const attr = node.model
    if (attr.type) {
      attributes.push(attr)
    }
  })
  return attributes
}



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/common/attributeTransformation.js